import React from "react";
import { useCurrency, isUSD, formatAwgExact, usdEquivalent } from "@/lib/currency";
import { getAwgPerUsd } from "@/lib/api";

// Shown before confirmation whenever prices are displayed in USD: states
// the exact AWG amount Sentoo will charge (AWG remains authoritative).
export const ChargeDisclosure = ({ awgTotal, className = "", testId = "charge-disclosure" }) => {
  useCurrency();
  if (!isUSD() || !(Number(awgTotal) > 0)) return null;
  return (
    <p
      data-testid={testId}
      className={`text-[11px] leading-relaxed text-[#A3A3A3] ${className}`}
    >
      You'll be charged <span className="text-white font-semibold">{formatAwgExact(awgTotal)}</span>{" "}
      ({usdEquivalent(awgTotal)}) in Aruban florins (incl. tax) at the fixed rate of{" "}
      {getAwgPerUsd()} AWG = US$ 1. US$ totals above use rounded list prices; the figure here is
      the exact conversion of the amount charged.
    </p>
  );
};
